import * as yup from "yup";

const minDate = 1514764800000;
const dayInMs = 60 * 60 * 24 * 1000;
// The current date + 1 day so we can view data up to today
const latestDate = Date.now() + dayInMs;
export const dateRangeValidation = (id?: string) => {
  const startDateId = id ? `${id}-start-date` : "fromDate";
  const endDateId = id ? `${id}-end-date` : "toDate";
  return yup.object().shape({
    [startDateId]: yup
      .number()
      .typeError("A valid date in DD/MM/YYYY format is needed")
      .required("A valid date in DD/MM/YYYY format is needed")
      .max(latestDate, "Future date not allowed")
      .min(minDate, "Date cannot be earlier than January 1, 2018")
      .test(
        "is-before-end-date",
        "The start date must be before the end date",
        function (value) {
          const { parent } = this;
          const endDate = parent[endDateId];
          if (value === undefined || value < 0 || endDate === undefined) {
            return this.createError({
              message: "A valid date in DD/MM/YYYY format is needed",
            });
          }
          if (value > endDate) {
            return this.createError({
              message: "The start date must be before the end date",
            });
          }
          return true;
        },
      ),
    [endDateId]: yup
      .number()
      .typeError("A valid date in DD/MM/YYYY format is needed")
      .required("A valid date in DD/MM/YYYY format is needed")
      .max(latestDate, "Future date not allowed")
      .min(
        minDate,
        "End date cannot be earlier than January 1, 2018, or the start date",
      )
      .test(
        "is-after-start-date",
        "The end date must be after the start date",
        function (value) {
          const { parent } = this;
          const startDate = parent[startDateId];
          if (value === undefined || value < 0 || startDate === undefined) {
            return this.createError({
              message: "A valid date in DD/MM/YYYY format is needed",
            });
          }
          if (value < startDate) {
            return this.createError({
              message: "The end date must be after the start date",
            });
          }
          return true;
        },
      ),
  });
};
